import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";



const OfflineIndicator = () => (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        // backgroundColor: "rgba(255, 0, 0, 0.9)",
        color: "white",
        padding: "20px 40px",
        borderRadius: "8px",
        zIndex: 1000,
        textAlign: "center",
        // boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <CircularProgress style={{ color: "black" }} />
    </div>
  );

  export default OfflineIndicator;
 